import { useMessages, useBlockTheme } from "@quillforms/renderer-core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

/**
 * WordPress Dependencies
 */
import { useEffect, useState } from "react";

/**
 * External Dependencies
 */
import tinyColor from "tinycolor2";
import { css } from "emotion";
import classnames from "classnames";

const DatePickerBlock = (props) => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    val,
    setVal,
    showErrMsg,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isPreview,
    isReviewing,
  } = props;
  const theme = useBlockTheme(attributes.themeId);
  const messages = useMessages();
  const answersColor = tinyColor(theme.answersColor);
  const { required, defaultValue } = attributes;

  const startDate = new Date();
  startDate.setDate(startDate.getDate() + 4);

  const endDate = new Date();
  endDate.setDate(startDate.getDate() + 9);

  const checkFieldValidation = (value) => {
    if (required === true && (!value || value === "" || value.length === 0)) {
      setIsValid(false);
      setValidationErr(
        messages["label.errorAlert.required"] || "This field is required"
      );
      // check if value is between start and end date
    } else if (value && value.length > 0) {
      const date = new Date(value);
      if (date < startDate || date > endDate) {
        setIsValid(false);
        setValidationErr(
          messages["label.errorAlert.dateRange"] ||
            "Please select a date between 5 and 14 days from today."
        );
      } else {
        setIsValid(true);
        setValidationErr(null);
      }
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };

  useEffect(() => {
    if (isPreview || !isReviewing) checkFieldValidation(val);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [required]);

  const defaultSelectedDate = new Date();
  defaultSelectedDate.setDate(defaultSelectedDate.getDate() + 5);
  const [selectedDate, setSelectedDate] = useState(defaultSelectedDate);

  const changeHandler = (date) => {
    const value = date.toLocaleDateString();
    checkFieldValidation(value);
    setVal(value);
    showErrMsg(false);
    if (!value) {
      setIsAnswered(false);
    } else {
      setIsAnswered(true);
      setSelectedDate(date);
      showNextBtn(true);
    }
  };

  const renderDayContents = (day, date) => {
    if (date < startDate || date > endDate)
      return (
        <span style={{ color: "gray", textDecoration: "line-through" }}>
          {day}
        </span>
      );

    return <span>{day}</span>;
  };

  return (
    <DatePicker
      ref={inputRef}
      selected={selectedDate}
      onChange={changeHandler}
      renderDayContents={renderDayContents}
      className={classnames(
        css`
          & {
            width: 100%;
            border: none !important;
            outline: none;
            padding-bottom: 8px !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            border-radius: 0 !important;
            background: transparent;
            background-color: transparent !important;
            transition: box-shadow 0.1s ease-out 0s;
            -webkit-appearance: none;
            box-shadow: ${answersColor.setAlpha(0.3).toString()} 0px 1px !important;
          }

          &::placeholder {
            opacity: 0.3;
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${theme.answersColor};
          }

          &:-ms-input-placeholder {
            opacity: 0.3;
            /* Internet Explorer 10-11 */
            color: ${theme.answersColor};
          }

          &::-ms-input-placeholder {
            opacity: 0.3;
            /* Microsoft Edge */
            color: ${theme.answersColor};
          }

          &:focus {
            box-shadow: ${answersColor.setAlpha(1).toString()} 0px 2px !important;
            border: none !important;
            outline: none !important;
          }

          color: ${theme.answersColor} !important;
        `
      )}
      id={"date-picker-" + id}
      data-ref={id}
      value={val && val.length > 0 ? val : defaultValue ?? ""}
      onFocus={() => {
        if (isTouchScreen) {
          setFooterDisplay(false);
        }
      }}
      onBlur={() => {
        if (isTouchScreen) {
          setFooterDisplay(true);
        }
      }}
    />
  );
};

export default DatePickerBlock;
